import CommonLandingContainer from 'src/components/landingComponents/containers/common';
import styles from './footer.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
} from 'src/components/landingComponents/typography';
import { ReactComponent as LametriLogo } from 'src/assets/img/landing/footerLogo.svg';
import { ReactComponent as Delimeter } from 'src/assets/img/landing/footerDelimeter.svg';
import { Box, Link } from '@mui/material';
import { ReactComponent as TelegramLogo } from 'src/assets/img/TelegramLogo.svg';
import { NavItem } from 'src/components/_views/landingMain/header';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';

const navContent = [
  { link: 'orderRequest', title: 'Результаты' },
  { link: 'about?show=oak', title: 'Популярные тесты' },
  { link: 'howto?show=instructions', title: 'Как пользоваться системой' },
  { link: 'questions?inputType=manual', title: 'Ручной ввод' },
];

const Footer = () => {
  return (
    <AnimatedBox className={getClassName([styles.development])}>
      <footer className={styles.container}>
        <LametriLogo className={styles.logo} />
        <div className={styles.top}>
          <Menu></Menu>
          <Delimeter className={styles.delimeter} />
        </div>
        {/* <div className={styles.bottom}></div> */}
        <Support />
      </footer>
    </AnimatedBox>
  );
};

export default Footer;

const Support = () => {
  return (
    <div className={styles.support}>
      <div className={styles.supportText}>
        <Body className={styles.supportTitle}>Поддержка:</Body>
        <Body className={styles.supportMail}>support@lametri.ru</Body>
      </div>
      <Link
        className={styles.telegramLink}
        href="https://t.me/lamettrie"
        underline="none"
        rel="nofollow"
      >
        <Body className={styles.copyright}>© 2023 - 2025 Ламетри</Body>
        <TelegramLogo style={{ width: '24px', height: '24px' }}></TelegramLogo>
        <Body className={styles.telegramTitle}>@lamettrie</Body>
      </Link>
    </div>
  );
};

const Menu = () => {
  return (
    <div className={styles.menu}>
      {navContent.map((i) => {
        return (
          <NavItem
            key={i.link}
            {...i}
            textClassName={styles.menuText}
            textColor="white"
          />
        );
      })}
    </div>
  );
};
